/**
 * Google Input Tools
 *
 * Marks every page it loads on with a flag element carrying a shouty, unmistakable id.
 * Observed on version 11.4.0.0.
 */
import { probeSelector } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'mclkkofklkfljcocdinagocijmpgbhab';
export const googleInputTools: ExtensionDefinition = {
  id: ID,
  name: 'Google Input Tools',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 3_000_000,
  notes:
    'Identifies the visitor as someone typing in a non-Latin script — a stronger ' +
    'demographic hint than most extensions leak.',
  signals: [
    { id: 'dom-chext-flag', kind: 'dom',
      description: 'Look for <div id="GOOGLE_INPUT_CHEXT_FLAG">, injected into every page as an initialisation marker.',
      weight: 1, run: () => probeSelector('#GOOGLE_INPUT_CHEXT_FLAG', { timeoutMs: 1500 }) },
  ],
};
